import { makeStyles } from 'tss-react/mui';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean;
}

const useStyles = makeStyles<Props>({ name: 'QRCode' })((_, props) => ({
  img: {
    filter: darkOrLightStyle(props)('invert()', 'unset'),
  },
}));

export default useStyles;
